import React, { Component, Fragment } from 'react';
import ReactTooltip from 'react-tooltip';

const withTooltip = (BaseComponent) => {
  return class ComponentWrapped extends Component {
    constructor(props) {
      super(props);
      this.props = props;
    }

    render() {
      return (
        <Fragment>
          <BaseComponent {...this.props} />
          <ReactTooltip place='top' effect='float' multiline={true} type='dark' delayShow={0} />
        </Fragment>
      );
    }
  };
};

export default withTooltip;
